<template>
  <div>
    <!--closable这里说明home是不能关闭的-->
    <el-tag
      :key="tag.route"
      size="small"
      v-for="(tag, index) in tags"
      closable
      @close="handleClose(tag, index)"
      @click="changeMenu(tag)"
      :effect="$route.name === tag.route ? 'dark' : 'plain'"
      class="tagSt"
    >
      {{ tag.label }}
    </el-tag>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {

  computed: {
    //获取vuex的标签集合数据
    ...mapState({
      tags: state => state.tags.tabsList
    })
  },
  methods: {
    ...mapMutations({
      close: 'closeTab'
    }),
    //关闭标签
    handleClose(tag, index) {
      let length = this.tags.length - 1

      //vuex调方法的另一种写法
      this.close(tag)

        this.$store.commit('deleteMens', tag);
      // 如果关闭的标签不是当前路由的话，就不跳转
      if (tag.route !== this.$route.name) {
        return
      }

      // 关闭的标签是最右边的话，往左边跳转一个
      if (index === length) {
        this.$router.push({ name: this.tags[index - 1].route });
        //判断右侧导航栏
        // if (this.tags[index - 1].level == 2) {
        //   this.$emit("tagBackInfo",this.tags[index - 1],false);
        // }else{
        //   this.$emit("tagBackInfo",this.tags[index - 1],true);
        // }
      } else {
        // 否则往右边跳转
        this.$router.push({ name: this.tags[index].route });
        //判断右侧导航栏
        // if (this.tags[index].level == 2) {
        //   this.$emit("tagBackInfo",this.tags[index],false);
        // }else{
        //   this.$emit("tagBackInfo",this.tags[index],true);
        // }
      }

    },

    //选择标签跳转路由
    changeMenu(item) {
     /* if (item.level == 2) {
        this.$emit("tagBackInfo",item,false);
      }else{
        this.$emit("tagBackInfo",item,true);
      }*/
      this.$router.push({ name: item.route });
      this.$store.commit('selectMenu', item);
       // store.commit('SETCHECK', to.meta.check)
    }
  },
}
</script>
<style scoped>
.tagSt{
  cursor: pointer;
  margin: 5px 10px;
}
 .el-tag--dark {
  background: #32b9f5;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  height: 26px;
  line-height: 26px;
  letter-spacing: 0px;
  color: #ffffff !important;
}
.el-tag:not(.is-active) {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 26px;
  letter-spacing: 0px;
  color: #707070;
  border: none;
}


</style>
